import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import History from './views/History.vue'
import FeeList from './views/FeeList.vue'
import Bind from './views/Bind.vue'
import Pay from './views/Pay.vue'

Vue.use(Router)

const router=new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
        ,meta:{
            title:'官塘镇自来水缴费'
        }
    },
    {
      path: '/history',
      name: 'history',
      component: History
        ,meta:{
          title:'历史缴费记录'
        }
    },
    {
      path: '/fee',
      name: 'fee',
      component: FeeList
        ,meta:{
            title:'待缴费记录'
        }
    },
    {
      path: '/bind',
      name: 'bind',
      component: Bind
        ,meta:{
            title:'绑定'
        }
    },
    {
      path: '/pay',
      name: 'pay',
      component: Pay
        ,meta:{
            title:'支付...'
        }
    }
  ]
})

export default router;